@if (open) {
  <div @backgroundAnimation class="sheet-background" (click)="closeSheet()"></div>
  <div @sheetAnimation class="sheet">
    <ng-content></ng-content>
  </div>
}
